"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[480px] bg-card/40 backdrop-blur-md border border-border animate-pulse shadow-md" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-16">
        <p className="text-sm text-muted-foreground font-sans">
          Gagal memuat berita terbaru.{" "}
          <Button onClick={refetch} variant="link" className="text-primary underline ml-2 h-auto p-0">
            Coba Lagi
          </Button>
        </p>
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground font-sans text-center py-16">
        Belum ada berita untuk ditampilkan.
      </p>;
  }
  const categoryLabels = ["BERITA UTAMA", "AKTIVITAS ORGANISASI", "INFORMASI PUBLIK"];
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.slice(0, 3).map((post, i) => {
      const categoryLabel = post.categories && post.categories.length > 0 ? post.categories[0].name.toUpperCase() : categoryLabels[i % categoryLabels.length];
      const dateStr = post.date ? new Date(post.date).toLocaleDateString("id-ID", {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }).toUpperCase() : "";
      return <Link key={post.id} data-index={i} to={post.link || "#"} className="group relative flex flex-col bg-card/40 backdrop-blur-md border border-border shadow-md transition-all duration-300 hover:shadow-lg">
            {}
            <span className="absolute top-0 left-0 right-0 h-px bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            {}
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-muted to-secondary" />}
              {}
              <div className="absolute inset-x-0 bottom-0 h-1/2 pointer-events-none" style={{
            background: "linear-gradient(to top, hsl(25 83% 55% / 0.15) 0%, transparent 100%)"
          }} />
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-card to-transparent pointer-events-none" />
            </div>

            {}
            <div className="flex flex-col gap-4 p-6 flex-1">
              <span className="text-xs uppercase tracking-widest text-primary font-sans font-medium">
                {categoryLabel}
              </span>

              <h3 className="text-xl font-default font-bold leading-tight tracking-tight line-clamp-2 text-foreground" style={{
            letterSpacing: "-0.01em"
          }}>
                {post.title}
              </h3>

              <div className="border-t border-border mt-auto pt-4 flex items-center justify-between">
                <span className="text-xs uppercase tracking-widest text-muted-foreground font-sans">
                  {dateStr}
                </span>
                <ArrowUpRight className="size-4 text-primary transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-1" strokeWidth={2} />
              </div>
            </div>
          </Link>;
    })}
    </div>;
}
export default function Sidebar() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="4039" id="sidebar" className="bg-background text-foreground py-24 md:py-40 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 mb-16 md:mb-20">
          <div className="flex flex-col gap-6">
            <span className="text-xs uppercase tracking-widest text-primary font-sans font-medium">
              05 / BERITA TERKINI
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-[3rem] font-default font-bold leading-[1.05] tracking-tight" style={{
            letterSpacing: "-0.02em"
          }}>
              Informasi terbaru dari organisasi kami.
            </h2>
          </div>

          <div className="flex flex-col justify-between gap-6 lg:items-end lg:text-right">
            <p className="text-base md:text-lg font-sans text-muted-foreground leading-relaxed max-w-md">
              Dapatkan pembaruan terkini mengenai kegiatan, aksi sosial, dan kebijakan terbaru dari organisasi kami untuk seluruh anggota dan masyarakat luas.
            </p>
            <Link to="/NewsPage" className="inline-flex items-center gap-2 text-sm font-sans uppercase tracking-widest text-primary hover:gap-3 transition-all duration-300">
              Lihat semua berita
              <ArrowRight className="size-4" strokeWidth={2} />
            </Link>
          </div>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <PostsGridConsumer />
        </PostsProvider>

        {}
        <div className="flex justify-center mt-16 md:mt-20">
          <Link to="/NewsPage">
            <Button variant="outline" size="lg" className="bg-transparent border-border text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary font-sans uppercase tracking-widest text-xs px-10 h-14 shadow-md transition-all duration-300">
              Jelajahi semua informasi
              <ArrowRight className="size-4 ml-2" strokeWidth={2} />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}